import InventoryView from "../../components/inventory/InventoryView";

export function InventoryPage() {
  return <InventoryView />;
}

export default InventoryPage;
